import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ss-expand",
  "use": "ss-expand-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 15 15\" id=\"ss-expand\"><g style=\"mix-blend-mode:passthrough\"><ellipse cx=\"7.5\" cy=\"7.5\" rx=\"7.5\" ry=\"7.5\" fill=\"#FFFFFF\" fill-opacity=\"1\" /><ellipse cx=\"7.5\" cy=\"7.5\" rx=\"6.5\" ry=\"6.5\" fill-opacity=\"0\" stroke-opacity=\"1\" stroke=\"#297DFD\" fill=\"none\" stroke-width=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol